const FALLBACK_ERROR = 'Audio processing failed. Please try again with the original audio file.';

export function getProcessErrorMessage(process) {
    const error = process?.error;

    if (!error) return '';
    if (error.startsWith('Command failed:') || error.length > 500) {
        return FALLBACK_ERROR;
    }

    return error;
}

export function getDisplayedStepStatus(processStatus, stepStatus) {
    if (processStatus === 'error' && stepStatus === 'started') {
        return 'error';
    }
    if (processStatus === 'completed' && stepStatus === 'started') {
        return 'finished';
    }

    return stepStatus;
}
